/* CORTO Kit-Finder im Burger-Menü – Fragen sind serverseitig gerendert, JS schaltet nur Schritte um */
(function () {
  if (customElements.get('corto-kit-finder')) return;
  var KIT_INDEX = { ck: 0, cp: 1, md: 2 };

  class CortoKitFinder extends HTMLElement {
    connectedCallback() {
      this.step = 0;
      this.answers = [];
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', (e) => {
        var opt = e.target.closest('.cmd-opt');
        if (opt && this.contains(opt)) {
          this.answers[this.step] = opt.dataset.score || '';
          this.step += 1;
          return this.apply();
        }
        if (e.target.closest('[data-back]')) {
          if (this.step > 0) { this.step -= 1; this.answers.length = this.step; }
          return this.apply();
        }
        if (e.target.closest('[data-reset]')) {
          this.step = 0; this.answers = [];
          return this.apply();
        }
      });
    }

    apply() {
      var steps = this.querySelectorAll('[data-step]');
      var total = steps.length;
      var done = this.step >= total;
      steps.forEach((el) => { el.hidden = Number(el.dataset.step) !== this.step; });
      this.querySelectorAll('.cmd-segs span').forEach((el, i) => el.classList.toggle('is-on', i < this.step));
      var result = this.querySelector('[data-result]');
      if (result) result.hidden = !done;
      if (!done) return;

      var score = { ck: 0, cp: 0, md: 0 };
      this.answers.forEach((str) => {
        str.split(',').forEach((pair) => {
          var kv = pair.split(':');
          if (kv[0] in score) score[kv[0]] += Number(kv[1]) || 0;
        });
      });
      var best = 'ck';
      ['cp', 'md'].forEach((k) => { if (score[k] > score[best]) best = k; });
      var idx = String(KIT_INDEX[best]);
      this.querySelectorAll('[data-kit]').forEach((el) => { el.hidden = el.dataset.kit !== idx; });
    }
  }

  customElements.define('corto-kit-finder', CortoKitFinder);
})();
